type GameFileType = "casinogames" | "populargames" | "instantgames" | "slotgames";
type BrandId = 31 | 32 | 33 | 34 | 39 | 40 | 46 | 47 | 61;

const fallbackBrandMap: Record<number, BrandId> = {
    31: 31,
    32: 31,
    33: 33,
    34: 33,
    39: 39,
    40: 39,
    46: 47,
    47: 47,
    61: 61,
};

export const getGamesJsonData = async (fileKey: GameFileType, brandId: number | string) => {
    const resolvedBrandId = fallbackBrandMap[Number(brandId)] || 31;
    const fileName = `${fileKey}${resolvedBrandId}`;

    try {
        const data = await import(`src/static/game-data/${fileName}.json`);
        return data.default;
    } catch (error) {
        console.error(`[loadGameJson] Failed to load ${fileName}.json`, error);
        return {};
    }
};